import React, { createContext, useContext, useState, useEffect } from 'react';
import { base44 } from '@/api/base44Client';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);
  const [isLoadingPublicSettings, setIsLoadingPublicSettings] = useState(true);
  const [authError, setAuthError] = useState(null);
  const [user, setUser] = useState(null);
  const [isPublicApp, setIsPublicApp] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      try {
        // App is public by default
        setIsPublicApp(true);
        setIsLoadingPublicSettings(false);

        // Try to get user — single call instead of isAuthenticated() + me()
        try {
          const currentUser = await base44.auth.me();
          setUser(currentUser);
        } catch (error) {
          // User not authenticated — fine for a public app
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
      } finally {
        setIsLoadingAuth(false);
      }
    };

    initialize();
  }, []);

  const navigateToLogin = () => {
    base44.auth.redirectToLogin(window.location.pathname);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoadingAuth,
        isLoadingPublicSettings,
        authError,
        user,
        isPublicApp,
        navigateToLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};